import React from 'react';
import { useHistory } from 'react-router-dom';
import { DATE_FORMATS, VERTICALS } from '../../../../constants/app-constant';
import { TAGS } from '../../../../constants/route-constants';
import { formatDate } from '../../../../utility/common-methods';
import { EditIcon, DeleteIcon } from '../../../Icons/icons.component';

const TagsList = ({ tagsList = [], setDeleteModal, setEditModal, setEditId }) => {
  const history = useHistory();
  const { V_BLOG, V_SOCIAL, V_FORUM } = VERTICALS;
  const dateId = Date.now()

  const handleEditClick = (e, id, name) => {
    e.stopPropagation();
    setEditModal(true);
    setEditId({ name, editId: id });
  };

  const handleDeleteClick = (e, id) => {
    e.stopPropagation();
    setDeleteModal(true);
    setEditId({ editId: id });
  };

  const handleColumnClick = (vertical, tagId, name) => {
    history.push(`${TAGS}/${tagId}/${vertical}?name=${name}`);
  };

  return (
    <>
      <div className="table-responsive">
        <table className="table customTableTwo tagsListingTable">
          {
            tagsList && tagsList.length > 0 && (
              <thead>
                <tr className="topicRow" key={dateId}>
                  <th className="thTags">Tags</th>
                  <th className="thDateAdded">Date Added</th>
                  <th className="thSocial">Social</th>
                  <th className="thBlogs">Blogs</th>
                  <th className="thForums">Forums</th>
                  <th className="thAction">Action</th>
                </tr>
              </thead>
            )
          }
          <tbody>
            {Array.isArray(tagsList) &&
              tagsList.map((item) => {
                if (!item) {
                  return null;
                }
                const {
                  id,
                  name,
                  social_count,
                  blog_count,
                  forum_count,
                  createdAt,
                  updatedAt } = item || {};
                return (
                  <>
                    <tr key={id}>
                      <td className="thTags">{name}</td>
                      <td className="thDateAdded">{formatDate(createdAt, DATE_FORMATS.DDMMYYYY_dash)}</td>
                      <td className="thSocial">
                        <span className="link" onClick={() => handleColumnClick(V_SOCIAL, id, name)}>{social_count}</span>
                      </td>
                      <td className="thBlogs">
                        <span className="link" onClick={() => handleColumnClick(V_BLOG, id, name)}>{blog_count}</span>
                      </td>
                      <td className="tag-vertical">
                        <span className="link" onClick={() => handleColumnClick(V_FORUM, id, name)}>{forum_count}</span>
                      </td>
                      <td className="thAction">
                        <span
                          className="actionLink edit"
                          onClick={(e) => handleEditClick(e, id, name)}
                        >
                          <div className="hasTooltip">
                            <EditIcon />
                            <span className="tooltipWrap center">Edit</span>
                          </div>
                        </span>
                        {/* <span
                          className="actionLink delete"
                          onClick={(e) => handleDeleteClick(e, id)}
                        >
                          <div className="hasTooltip">
                            <DeleteIcon />
                            <span className="tooltipWrap center">Delete</span>
                          </div>
                        </span> */}
                      </td>
                    </tr>
                  </>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  )
};

export default TagsList;
